import { render, staticRenderFns } from "./ReceiptsList.vue?vue&type=template&id=b64b2c3a&scoped=true&"
import script from "./ReceiptsList.vue?vue&type=script&lang=js&"
export * from "./ReceiptsList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsList.vue?vue&type=style&index=0&id=b64b2c3a&lang=scss&scoped=true&"
import style1 from "./ReceiptsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64b2c3a",
  null
  
)

export default component.exports